import axios from "axios";
import {
  API_BASE_URL,
  AXIOS_HEADERS_FILE,
} from "../../configs/variable.config";
import { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { INTERNAL_PATHS } from "../../configs/routes.config";

const VideoInput = (props) => {
  const [fileSrc, setFileSrc] = useState("");

  useEffect(() => {
    if (props.pageType === "edit") {
    }
  }, []);

  const OnChangeHandler = async (event) => {
    let imageDataUrl = await readFile(event.target.files[0]);
    fetch(imageDataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], event.target.files[0].name, {
          type: `${event.target.files[0].type}`,
        });
        setFileSrc(imageDataUrl);
        const formData = new FormData();
        formData.append("image", file);
        formData.append("type", props.type);
        const arrey = API_BASE_URL.split("/");
        const fileUrl = `https://${arrey[2]}/api/v1/admin/files`;
        //${API_BASE_URL}${INTERNAL_PATHS.FILES}
        axios.post(`${fileUrl}`, formData).then((res) => {
          if (props.HasManyInputData) {
            props.HasManyInputData(
              props.index,
              props.HasManyKey,
              res.data.data.id,
            );
          } else {
            let object = props.inputData;
            object[props.keyValue] = res.data.data.id;
            props.setInputData(object);
          }
        });
      });
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }

  return (
    <>
      <div>
        <Tooltip
          title={props.item.help === undefined ? "" : props.item.help.body}
          placement="left-start"
          arrow
        >
          <label className="text-[14px] dark:text-[#D1D4C9] text-edit_input_label col-span-full sm:col-auto mb-1 mt-5 sm:mb-0 sm:mt-0">
            {props.item.label}
          </label>
        </Tooltip>
      </div>
      <div className="col-span-full ">
        <div className="flex items-center gap-2 ">
          {fileSrc === "" ? (
            <div className="relative">
              <button
                className="w-32 h-10 rounded-md bg-[#9398e4] flex items-center justify-center text-white dark:text-black dark:bg-[#ffffffdd]"
                alt=""
              >
                آپلود ویدیو
              </button>
              <input
                className="opacity-0 absolute top-0 w-32 h-10 cursor-pointer"
                disabled={props.disabled}
                onChange={OnChangeHandler}
                index={props.index}
                accept="video/*"
                type="file"
              />
            </div>
          ) : (
            <video width="750" height="500" controls>
              <source src={fileSrc} type="video/mp4" />
            </video>
          )}
        </div>
        <div className="mt-2 text-[.8rem] text-edit_input_validation">
          {props.children}
        </div>
      </div>
    </>
  );
};

export default VideoInput;
